/**
 * Shared email validation regex.
 * Matches: user@domain.tld (basic format check, not RFC 5322 compliant).
 */
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
